<template>
	<div class="cco-productAddToCart">
		<!-- STOCK -->
		<div
			class="cco-productAddToCart__stock"
			v-if="purchasable.stock.status == 'STOCK'"
		>
			<Spinner version="product" @updated="updateValue"> </Spinner>
			<button
				:aria-label="addToCartLabel"
				class="o-btn o-btn--fill"
				:class="{ 'o-btn--disabled': !isAvailableForPurchase }"
				:disabled="!isAvailableForPurchase"
				@click="updateCart"
			>
				<TransitionGroup name="fade">
					<Loader v-if="loading && !complete"></Loader>
					<AniAddedToCart v-if="!loading && complete"></AniAddedToCart>
					<span v-if="!loading && !complete">{{ addToCartLabel }}</span>
				</TransitionGroup>
			</button>
		</div>

		<!-- BACKORDER -->
		<div
			class="cco-productAddToCart__stock"
			v-if="purchasable.stock.status == 'BACKORDER'"
		>
			<Spinner version="product" @updated="updateValue"> </Spinner>
			<button
				class="o-btn o-btn--fill"
				@click="updateCart"
				:aria-label="translations['Backorder']"
			>
				<TransitionGroup name="fade">
					<Loader v-if="loading && !complete"></Loader>
					<AniAddedToCart v-if="!loading && complete"></AniAddedToCart>
					<span v-if="!loading && !complete">{{
						translations["Backorder"]
					}}</span>
				</TransitionGroup>
			</button>
		</div>

		<!-- PREORDER -->
		<div
			class="cco-productAddToCart__preorder"
			v-if="purchasable.stock.status == 'PREORDER'"
		>
			<Spinner version="product" @updated="updateValue"> </Spinner>
			<button
				class="o-btn o-btn--fill"
				@click="updateCart('preorder')"
				:aria-label="translations['Preorder']"
			>
				<TransitionGroup name="fade">
					<Loader v-if="loading && !complete"></Loader>
					<AniAddedToCart v-if="!loading && complete"></AniAddedToCart>
					<span v-if="!loading && !complete">{{
						translations["Preorder"]
					}}</span>
				</TransitionGroup>
			</button>
		</div>

		<Splitpay :active="splitpayActive"></Splitpay>

		<div class="cco-productAddToCart__trustpilot">
			<TrustBox template="review" locale="da"></TrustBox>
		</div>

		<Usp :product="product" :purchasable="purchasable"></Usp>

		<!-- OUT OF STOCK -->
		<div
			class="cco-productAddToCart__outofstock"
			v-if="purchasable.stock.status == 'OUTOFSTOCK'"
		>
			<NotifyStock :id="purchasable.id"></NotifyStock>
			<AlternativeProducts :id="product.id"></AlternativeProducts>
		</div>
	</div>
</template>

<script>
import request from "@/vue/mixins/request.js";

//Components
import Loader from "../../objects/Loader.vue";
import AniAddedToCart from "@/vue/components/animation/AddedToCart.vue";
import Spinner from "@/vue/components/commerce/objects/Spinner.vue";
import * as map from "@/vue/mixins/map";

import Usp from "@/vue/components/commerce/objects/Usp.vue";
import Splitpay from "@/vue/components/commerce/objects/Splitpay.vue";
import AlternativeProducts from "@/vue/components/commerce/objects/AlternativeProducts.vue";
import NotifyStock from "@/vue/components/commerce/objects/NotifyStock.vue";
import TrustBox from "../../objects/TrustBox.vue";

export default {
	name: "ProductAddToCart",
	mixins: [request, map.cart],
	components: {
		Spinner,
		AniAddedToCart,
		Loader,
		Usp,
		Splitpay,
		AlternativeProducts,
		NotifyStock,
		TrustBox,
	},
	props: {
		purchasable: {
			type: Object,
		},
		product: {
			type: Object,
		},
		alternatives: {
			type: Array,
		},
	},
	data: () => {
		return {
			typeData: "full",
			addToCartAmount: 1,

			complete: false,
		};
	},
	computed: {
		splitpayActive() {
			return this.purchasable.stock.status !== "OUTOFSTOCK" ? true : false;
		},
		isAvailableForPurchase() {
			// TODO: Fix for bundles
			return true;
			// return this.purchasable.availableForPurchase;
		},
		addToCartLabel() {
			return this.isAvailableForPurchase
				? this.translations["Add to cart"]
				: this.translations["Not available"];
		},
	},
	methods: {
		updateCart(type) {
			const formData = new FormData();
			formData.append("action", this.action.addToCart);

			formData.append("qty", this.addToCartAmount);
			formData.append("purchasableId", parseInt(this.purchasable.id));
			formData.append("stock", this.purchasable.stock.status);

			this.request(formData).then(() => {
				if (this.res.data?.cart) {
					this.$store.dispatch("commerce/cart", this.res.data.cart);

					this.complete = true;

					setTimeout(() => {
						this.complete = false;
					}, 1500);
				}
			});
		},
		updateValue(value) {
			this.addToCartAmount = value;
		},
	},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

.cco-productAddToCart {
	display: flex;
	flex-direction: column;
	width: 100%;
	margin-bottom: 40px;

	&__stock {
		margin-bottom: 16px;
		width: 100%;
		display: flex;
		gap: 16px;
	}

	&__preorder {
		margin-bottom: 16px;
		width: 100%;
		display: flex;
		gap: 16px;
	}

	&__outofstock {
		width: 100%;
		margin-top: 40px;
	}

	.o-btn {
		padding-inline: 16px;
		user-select: none;
	}

	&__trustpilot {
		margin-top: 10px;
		height: 42px;
		background-color: $c-greylight;

		display: flex;
		justify-content: center;
		align-items: center;
	}
}

@media all and (max-width: 950px) {
	.cco-productAddToCart {
		.c-usp {
			margin-top: 10px;
		}
	}
}

@media all and (max-width: 425px) {
	.cco-productAddToCart {
		&__stock,
		&__preorder {
			.cco-spinner {
				display: none;
			}
		}
	}
}
</style>
